import { intervalToDuration } from "date-fns";
import type { Duration } from "date-fns";

type FormatDurationParams = {
	seconds: number;
};

export const secondsToDurationParts = ({ seconds }: FormatDurationParams): Partial<Duration> => {
	if (seconds < 0) {
		return {};
	}
	if (seconds === 0) {
		return { seconds: 0 };
	}

	const milliseconds = seconds * 1000;

	const fullDuration = intervalToDuration({
		start: 0,
		end: milliseconds,
	});

	const result: Partial<Duration> = {};
	if (fullDuration.years) {
		result.years = fullDuration.years;
	}
	if (fullDuration.months) {
		result.months = fullDuration.months;
	}
	if (fullDuration.days) {
		result.days = fullDuration.days;
	}
	if (fullDuration.hours) {
		result.hours = fullDuration.hours;
	}
	if (fullDuration.minutes) {
		result.minutes = fullDuration.minutes;
	}
	if (fullDuration.seconds) {
		result.seconds = fullDuration.seconds;
	}

	if (Object.keys(result).length === 0 && seconds > 0) {
		result.seconds = fullDuration.seconds;
	}

	return result;
};
